import React from 'react'
import { boBreak, BoSizeClass } from './backoffice.tokens'

const PHONE_QUERY = `(max-width: ${boBreak.phoneMax - 1}px)`
const TABLET_QUERY = `(max-width: ${boBreak.tabletMax - 1}px)`

const read = (): BoSizeClass => {
	if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
		return 'desktop'
	}
	if (window.matchMedia(PHONE_QUERY).matches) return 'phone'
	if (window.matchMedia(TABLET_QUERY).matches) return 'tablet'
	return 'desktop'
}

const subscribe = (onChange: () => void) => {
	if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
		return () => {}
	}
	const a = window.matchMedia(PHONE_QUERY)
	const b = window.matchMedia(TABLET_QUERY)
	a.addEventListener('change', onChange)
	b.addEventListener('change', onChange)
	return () => {
		a.removeEventListener('change', onChange)
		b.removeEventListener('change', onChange)
	}
}

/**
 * 폭 등급 하나 — 폰 / 태블릿 / 데스크톱 (RESPONSIVE_PLAN §2 원칙 1).
 * 등급마다 **구조**가 달라서(판 수·네비·시트) CSS 만으로는 안 되고 렌더러를 고른다.
 * 단순 스타일 차이는 여전히 `boMedia.*` 문자열 키로 css 안에서 푼다.
 */
export const useBoSizeClass = (): BoSizeClass =>
	React.useSyncExternalStore(subscribe, read, () => 'desktop')

export const useIsPhone = (): boolean => useBoSizeClass() === 'phone'
